/**
 * @generated SignedSource<<0079ec0a17b0f8593b69119b804c8bed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type releaseNotesButton_softwareReleasesVersionDetail$data = {
  readonly id: string;
  readonly " $fragmentType": "releaseNotesButton_softwareReleasesVersionDetail";
};
export type releaseNotesButton_softwareReleasesVersionDetail$key = {
  readonly " $data"?: releaseNotesButton_softwareReleasesVersionDetail$data;
  readonly " $fragmentSpreads": FragmentRefs<"releaseNotesButton_softwareReleasesVersionDetail">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "releaseNotesButton_softwareReleasesVersionDetail",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "05a2c1a8fb9ea7ab5acb19f863afe1aa";

export default node;
